import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthenticationService } from '../authentication.service';
import { OffersParentComponent } from '../classes/OffersParentComponent';
import { GenresService } from '../genres.service';
import { StorageHelper } from '../helpers/StorageHelper';
import { UrlValidator } from '../helpers/UrlValidater';
import { InfoService } from '../info.service';
import { OffersService } from '../offers.service';
import { OwnListService } from '../own-list.service';
import { SeoService } from '../seo.service';
import { SettingsService } from '../settings.service';
import { ThemeService } from '../theme.service';
import { WishlistService } from '../wishlist.service';
import { Location } from "@angular/common";
import { Global } from '../classes/Global';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { BlocklistService } from '../blocklist.service';

@Component({
  selector: 'app-studios',
  templateUrl: './studios.component.html',
  styleUrls: ['./studios.component.scss'],
  providers: [ OffersService, GenresService, InfoService,
    WishlistService, AuthenticationService, OwnListService ]
})
export class StudiosComponent extends OffersParentComponent implements OnInit {

  studios: string = "";
  canGoBack: boolean = false;
  filtersShown: boolean = true;

  constructor(
    private offersService: OffersService,
    private location: Location,
    protected route: ActivatedRoute,
    protected router: Router,
    protected genresService: GenresService,
    protected infoService: InfoService,
    protected wishlistService: WishlistService,
    protected blocklistService: BlocklistService,
    protected authenticationService: AuthenticationService,
    protected ownlistService: OwnListService,
    protected settingsService: SettingsService,
    protected themeService: ThemeService,
    protected seoService: SeoService,
  ) {
    super(genresService, router, route, authenticationService, infoService, wishlistService, blocklistService, ownlistService, settingsService, themeService, seoService);
  }

  ngOnInit() {

    UrlValidator.validateUrl(this.route, this.router, 'on-sale', this);
    this.canGoBack = history && history.state && history.state['navigationId'] && history.state['navigationId'] > 1;
    this.listType = Global.AZ;
    StorageHelper.getInstance().save(StorageHelper.keys.listType, this.listType);
    super.onInit();
    this.getInfoFromUrl().then(() => {
      this.loadGenreAndItems();
    });

  }

  back() {
    this.location.back();
  }

  getInfoFromUrl() {

    return new Promise<void>((resolve, reject) => {

      //Notifier
      const ngUnsubscribe: Subject<any> = new Subject();

      //Get the additional listType parameter
      this.route.params.pipe(takeUntil(ngUnsubscribe)).subscribe(params => {
        this.studios = params['ids'];

        //notifies that params have been received and route.params can be unsubscribed
        ngUnsubscribe.next();
        ngUnsubscribe.complete();

        resolve();
      });

    });

  }

  reload(newUrl: boolean, replaceUrl?: boolean) {
    let itemsPresentInCache = false;
    itemsPresentInCache = this.loadItemsFromCache();

    if (!itemsPresentInCache) {
      //Genres already loaded, load items only
      this.loadOffers();
    }
  }

  initSorting() {
    this.sortValues = [Global.RELEASE_DATE, Global.LATEST_PRICE_CHANGE, Global.PRICE];
    this.sortKey = Global.RELEASE_DATE;
  }

  //override - update sort without saving
  sortChanged(list: string, sortKey: string) {
    this.sortKey = sortKey;
    this.items = [];
    this.reload(false);
  }

  getOffers() {

    let selectedBundleFilterOption = this.selectedBundleFilterOption ? this.selectedBundleFilterOption['type'] : this.getBundleFilterOptions()[0]['type'];
    let selectedOffersFilterOption = this.selectedOffersFilterOption ? this.selectedOffersFilterOption['type'] : this.getOfferFilterOptions()[0]['type'];
    let selectedFrenchTitlesOption = this.selectedFrenchTitlesOption ? this.selectedFrenchTitlesOption['type'] : this.getFrenchTitlesOptions()[0]['type'];

    return this.offersService.getOffers(Global.getStore(), this.listType, Global.getCountry(),
    this.getMediaTypeForGetOffers(), this.formatMultiSelectionForServer(this.selectedGenres, this.genres),
    this.getQuality(), this.sortKey, this.offset, this.limit, undefined,
    this.getPriceTypeForServer(),
    this.formatMultiSelectionForServer(this.selectedAdvisoryRatings, this.advisoryRatings),
    "all", undefined,
    this.formatMultiSelectionForServer(this.selectedHdrFormatOptions, this.hdrFormatOptions),
    this.movieRatingsFilters, this.studios, this.formatMultiSelectionForServer(this.selectedPriceRanges, this.priceRanges),
      undefined, undefined, selectedOffersFilterOption, this.selectedReleaseYear, this.sortPeriodKey, selectedBundleFilterOption, this.selectedRuntime, selectedFrenchTitlesOption);
  }

  //We don't want saved filters to be used here

  //override
  getSavedGenres() {
    return null;
  }

  //override
  getReleaseYear(): string {
    return "";
  }

  //override
  getPriceRange() {
    return null;
  }

  //override
  getMovieRatingsFilters() {
    return null;
  }

  //override - Studio pages should use default quality (hd4k/hd), not saved filter from az list
  getSavedQuality() {
    return null;
  }

  //override - use default quality but don't save (avoid overwriting user's az list preference)
  initQuality() {
    this.qualityOptions = this.getQualityOptions();
    this.selectedQuality = this.qualityOptions[0];
  }

  //override - Studio pages use default "all", no storage
  getOffersFilter() {
    return null;
  }

  //override - use default offers filter but don't save
  initOffersFilter() {
    this.offersFilterOptions = this.getOfferFilterOptions();
    this.selectedOffersFilterOption = this.offersFilterOptions[0];
  }

  //override - update offers filter without saving
  offersFilterChanged(offersFilterOption) {
    this.selectedOffersFilterOption = offersFilterOption;
    this.reload(false);
  }

}
